import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fantasma',
  templateUrl: './fantasma.component.html',
  styleUrls: ['./fantasma.component.css']
})
export class FantasmaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
